import React from 'react'
import {Icon} from '@chakra-ui/react'

const FavouriteIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <g clipPath="url(#clip0_31_629)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7629 7.625C7.77493 7.625 4.54199 10.858 4.54199 14.846C4.54199 16.761 5.30276 18.5978 6.65695 19.9521C6.65694 19.9521 6.65696 19.9521 6.65695 19.9521L20.0002 33.2953L33.3436 19.9519C34.6977 18.5978 35.4585 16.7612 35.4585 14.8461C35.4585 10.858 32.2256 7.625 28.2376 7.625C26.3224 7.625 24.4858 8.38575 23.1318 9.73985L20.0001 12.8713L16.8691 9.74006C16.869 9.74004 16.8691 9.74007 16.8691 9.74006C15.5148 8.38583 13.678 7.625 11.7629 7.625ZM1.54199 14.846C1.54199 9.20111 6.11806 4.625 11.7629 4.625C14.4737 4.625 17.0735 5.70189 18.9904 7.61872L20.0002 8.62867L21.0104 7.61855C21.0104 7.61857 21.0104 7.61854 21.0104 7.61855C22.9271 5.70182 25.5269 4.625 28.2376 4.625C33.8826 4.625 38.4585 9.20125 38.4585 14.8461C38.4585 17.5569 37.3816 20.1565 35.4649 22.0732L20.0002 37.538L4.53562 22.0734C2.61884 20.1565 1.54199 17.5567 1.54199 14.846Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_31_629">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="matrix(-1 0 0 1 40 0.000244141)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default FavouriteIcon
